import React, { useContext } from "react";
import { Button, MobileContext } from "components/common";
import { toast, Slide, Flip } from "react-toastify";
import { css } from "glamor";
import { track } from "../../utils/analytics";

const referralLink = user => `${process.env.REACT_APP_DOMAIN}/?referral=${user.referral_code}`;

const copyLink = user => {
  let elt = Array.from(document.getElementsByClassName("referralLinkInput")).filter(x => x.offsetParent)[0],
      rm = false;
  if (!elt) {
    elt = document.createElement('textarea');
    elt.style.position = 'fixed';
    elt.style.top = '0';
    elt.style.left = '0';
    elt.style.opacity = '0';
    elt.value = referralLink(user);
    document.body.appendChild(elt);
    rm = true;
  }
  elt.focus();
  elt.select();
  document.execCommand("copy");
  track("DASHBOARD_REFERRAL_LINK_COPIED");
  if (document.selection) {
    document.selection.empty();
  } else if (window.getSelection) {
    window.getSelection().removeAllRanges();
  }
  if (rm) document.body.removeChild(elt);
};

const ReferralLinkButton = ({ user, children, ...props }) => {
  const { isMobile } = useContext(MobileContext);
  return <Button
    green
    onClick={() => {
      console.log("toasting in ReferralLinkButton", toast);
      toast.success("Link copied!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        hideProgressBar: true,
        closeButton: false,
        className: css({
          background: "#26E3BA"
        }),
        transition: isMobile ? Slide : Flip
      });
      copyLink(user);
    }}
    {...props}
  >
    {children}
  </Button>
};

export { referralLink, ReferralLinkButton };
